import http from "./http"
import jsonUtil from "@/utils/jsonUtil.js"
const refund = {
  /*申请退款 */
  add(articleId) {
    return http.post("refund/refund/insert?articleId=" + articleId)
  },

  //获取列表
  getList(page, size, model) {
    let query = jsonUtil.toQuery(model)
    return http.post("refund/refund/list?page=" + page + "&size=" + size, query)
  },

  //获取退款具体信息
  getInfo(articleId) {
    return http.post("refund/refund/infoOne?articleId=" + articleId)
  },
}
export default refund
